import KendoDataSourceBaseMixin from './KendoDataSourceBaseMixin'

export default {
    name: 'kendo-datasource',
    mixins: [ KendoDataSourceBaseMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/index.js